import type { YfAnchor } from "@content/prepSchema";

/**
 * One Young & Freedman reference as a line of text, in book order: section,
 * equations in parentheses, examples, problems, figures, pages, note. Several
 * examples are joined with ", " (a range is printed only if the source wrote one).
 */
export function formatAnchor(a: YfAnchor): string {
  const parts: string[] = [];
  if (a.section) parts.push(`§${a.section}`);
  if (a.equations) parts.push(...a.equations.map((equation) => `(${equation})`));
  if (a.examples)
    parts.push(
      `${a.examples.length > 1 || a.examples[0]?.includes("–") ? "Examples" : "Example"} ${a.examples.join(", ")}`,
    );
  if (a.problems) {
    const challenges = a.problems.filter((p) => p.startsWith("Challenge"));
    const plain = a.problems.filter((p) => !p.startsWith("Challenge"));
    if (plain.length > 0)
      parts.push(`${plain.length > 1 ? "Problems" : "Problem"} ${plain.join(", ")}`);
    parts.push(...challenges);
  }
  if (a.figures) parts.push(`fig. ${a.figures.join(", ")}`);
  if (a.pages) parts.push(`s. ${a.pages.join(", ")}`);
  if (a.note) parts.push(a.note);
  return `Y&F ${parts.join(", ")}`;
}
